import Vue from "vue";
import firebase from "firebase";
import { firestorePlugin } from "vuefire";

Vue.use(firestorePlugin, { wait: true });
Vue.config.productionTip = false;

// let config = {
//   apiKey: "AIzaSyBK9gu-w6_LCIxs2XMNdNpRohSJvrMeaGg",
//   authDomain: "ezcrs-uat.firebaseapp.com",
//   databaseURL: "https://ezcrs-uat-default-rtdb.firebaseio.com",
//   projectId: "ezcrs-uat",
//   storageBucket: "ezcrs-uat.appspot.com",
//   messagingSenderId: "950919011400",
//   appId: "1:950919011400:web:96a2f0d9a4c2c50c96cc7d"
// };
let config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
};
let app = firebase.initializeApp(config);
let fb = app.database();
export default fb;
